import type { WorldProposalLineageRecord } from "@/lib/world/review/worldProposalReview.types";

export function mergeWorldProposalLineage(
  current: Record<string, WorldProposalLineageRecord>,
  incoming: Record<string, WorldProposalLineageRecord>,
): Record<string, WorldProposalLineageRecord> {
  return {
    ...current,
    ...incoming,
  };
}